var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphFamilyActivities(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.667 36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BDD9FF",
    cx: 6.667,
    cy: 5.773,
    rx: 5.778,
    ry: 5.773
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    y: 13.333,
    width: 13.333,
    height: 21.333,
    rx: 2.667
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.333 42.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDBBB",
    cx: 6.667,
    cy: 5.778,
    r: 5.778
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFAB61",
    y: 13.333,
    width: 13.333,
    height: 14.667,
    rx: 2.667
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BDD9FF",
    cx: 6.667,
    cy: 5.773,
    rx: 5.778,
    ry: 5.773
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    y: 13.333,
    width: 13.333,
    height: 21.333,
    rx: 2.667
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.315 13.94a8.333 8.333 0 0 1 11.785 0 8.333 8.333 0 1 1 11.785 11.786L41.84 35.772a2.46 2.46 0 0 1-3.478 0L28.315 25.726l-.178-.183a8.333 8.333 0 0 1 .178-11.602z",
    fill: "#FF79C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphFamilyActivities);
export default __webpack_public_path__ + "static/media/icons_graph_family_activities.f12e028f705e315f22ee5a75e963f9c4.svg";
export { ForwardRef as ReactComponent };